import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=a4138bba&scoped=true&lang=html&"
import script from "./Categories.vue?vue&type=script&lang=js&"
export * from "./Categories.vue?vue&type=script&lang=js&"
import style0 from "./Categories.vue?vue&type=style&index=0&id=a4138bba&prod&lang=css&"
import style1 from "./Categories.vue?vue&type=style&index=1&id=a4138bba&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4138bba",
  null
  
)

export default component.exports